// extracted by mini-css-extract-plugin
export default {"wrapper":"ProSettings_wrapper__g8ZpH"};